<template>
  <CardFlat :isCard="isIs24" :class="$style.container">
    <FeaturedPlacement
      :language="locale as HgSupportedLanguage"
      :geoIds="geoIds"
      :isProduction="isProduction"
      :platform="platformTheme"
      :translations="{
        featuredAgenciesSectionTitle: t('agencies.featuredAgenciesHeadline'),
        agencyCTA: t('agencies.agencyCTA'),
        featuredAgenciesPreviewBadge: t('agencies.featuredAgenciesPreviewBadge'),
      }"
      data-testid="agencies-featured-section"
    >
      <template #agencyText>
        <span>
          {{ t('agencies.featuredAgenciesGenericDescription') }}
        </span>
      </template>
    </FeaturedPlacement>
  </CardFlat>
</template>
<script setup lang="ts">
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { FeaturedPlacement } from '@smg-real-estate/seeker-app-shared-components';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import CardFlat from '@/components/common/CardFlat.vue';
import { getCurrentPlatformTheme, isPlatformIs24 } from '@/helpers/platform';
import useGeoStore from '@/stores/useGeoStore';

const platformTheme = getCurrentPlatformTheme();
const { locale, t } = useI18n();
const isIs24 = isPlatformIs24();
const isProduction = import.meta.env.VUE_STAGE === 'prod';
const geoStore = useGeoStore();
const { searchLocation } = storeToRefs(geoStore);

const geoIds = computed<Array<string>>(() =>
  searchLocation.value ? [searchLocation.value.id] : [],
);
</script>
<style lang="scss" module>
@use '@/styles/variables' as *;

.container {
  div[class*='featuredAgenciesSection'] {
    margin-bottom: 0;

    div[class*='featuredAgenciesList'] {
      margin-bottom: 0;

      > div:last-child {
        border-bottom: none;

        > div {
          padding: 0;
        }
      }
    }
  }
}
</style>
